import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Organisation } from 'src/models/DTO/organisation/organisation';
import { Config } from '../../../infrastructure/config';
import { Partner } from '../../../models/DTO/partners/partner';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  private getPartnerDetailsURL: string = Config.api + 'organisation';

  constructor(private http: HttpClient) { }

  getPartnerInfo(partnerId: string) {
    return this.http.get<Organisation>(this.getPartnerDetailsURL + '/' + partnerId + '?include=contact,partner,returnAddress');
  }
}
